module.exports = __webpack_public_path__ + "static/media/green check mark.1ab3c59e.jfif";